import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../project/reusableComponents/AccordianForTeams';
import { RenderHeader } from '.';


export const RenderBankDetails = ({ user, bank, expanded, handleChange }) => {

    if (!bank) return <></>;

    return <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} elevation={0}>
        <AccordionSummary expandIcon={<span className='material-icons text-scogobgsky'> expand_more </span>} aria-controls='panel2bh-content' id='panel2bh-header'>
            <RenderHeader isVerfied={user.is_verified} title='Bank Details' />
        </AccordionSummary>
        <AccordionDetails>
            <div className='px-6'>

                <p className='flex items-center gap-2 font-normal py-2'>
                    <span className={'capitalize text-scogogray text-font11'}>Account Holder Name</span>
                    <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{user?.bank?.account_holder_name}</p>
                </p>
                <p className='flex items-center gap-2 font-normal py-2'>
                    <span className={'capitalize text-scogogray text-font11'}>Bank Name</span>
                    <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{bank.bank_name}</p>
                </p>

                <p className='flex items-center gap-2 font-normal py-2'>
                    <span className={'capitalize text-scogogray text-font11'}>Account Number</span>
                    <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{user?.bank?.account_number}</p>
                </p>

                <p className='flex items-center gap-2 font-normal py-2'>
                    <span className={'capitalize text-scogogray text-font11'}>IFSC Code</span>
                    <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{user?.bank?.ifsc_code}</p>
                </p>
                <p className='flex items-center gap-2 font-normal py-2'>
                    <span className={'capitalize text-scogogray text-font11'}>UPI VPA</span>
                    <p className='max-w-max truncate scogoprimary text-font10 font-medium flex items-center rounded-3px'>{user?.bank?.upi_id}</p>
                </p>
            </div>
        </AccordionDetails>
    </Accordion>
};
